import { jsxs as m, jsx as s } from "react/jsx-runtime";
import { InputElementTopSection as N } from "../components/input-element-top-section/input-element-top-section.js";
import e from "./radio-button-group.module.less.js";
const j = ({ id: n, value: t, name: c, label: i, isChecked: o, isDisabled: l, onChange: r }) => /* @__PURE__ */ m("div", { className: e.inputLabelWrapper, children: [
  /* @__PURE__ */ s(
    "input",
    {
      className: e.input,
      id: n,
      type: "radio",
      name: c,
      value: t,
      checked: o,
      disabled: l,
      onChange: r
    }
  ),
  /* @__PURE__ */ m("label", { htmlFor: n, className: [e.radioLabel, o ? e.checked : ""].join(" "), children: [
    /* @__PURE__ */ s("div", { className: [e.radioButton, o ? e.checked : ""].join(" ") }),
    i && /* @__PURE__ */ s("span", { className: e.radioText, children: i })
  ] }, n)
] }), x = ({
  label: n,
  radioButtons: t,
  name: c,
  value: i,
  isDisabled: o,
  helperText: l,
  errorText: r,
  orientation: h = "horizontal",
  onChange: u,
  onChangeNative: f
}) => {
  const b = (a) => {
    const d = a.target.name, p = a.target.value;
    typeof u == "function" && u(d, p), typeof f == "function" && f(a);
  };
  return /* @__PURE__ */ m("fieldset", { className: e.wrapper, children: [
    /* @__PURE__ */ s(N, { legend: n, helperText: l, errorText: r }),
    /* @__PURE__ */ s("div", { className: [e.radioWrapper, e[h], r ? e.error : ""].join(" "), children: t.map((a) => {
      const d = i === a.value, p = o || a.isDisabled;
      return /* @__PURE__ */ s(
        j,
        {
          ...a,
          onChange: b,
          name: c,
          isChecked: d,
          isDisabled: p
        },
        a.id
      );
    }) })
  ] });
};
export {
  x as RadioButtonGroup,
  x as default
};
